// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cWOR","rootMobile":"styles_rootMobile__2wrxo"};